// Badge artwork, keyed by the badge id get_user_badges (018) returns.
//
// The RPC still returns an emoji `icon` for every badge. That stays the
// fallback: a badge added in SQL before its art exists renders its emoji
// instead of a broken image, so the two can ship separately.
//
// Sources are 1254px originals in the gitignored /assets/badges/. The files
// here are trimmed, 288px and palette-quantised (~5–10 KB each). A replacement
// saved under the same name needs a CACHE_NAME bump in public/sw.js to reach
// existing installs.
const ART_IDS = new Set([
  'verified_dsp',
  'first_post',
  'community_contributor',
  'helpful_voice',
  'table_regular',
  'complete_profile',
]);

export function badgeArt(id) {
  return ART_IDS.has(id) ? `/assets/badges/${id}.png` : null;
}

// The Verified DSP celebration draws its check in code over an emptied seal.
// Both layers keep the ORIGINAL 1254×1254 frame, because CHECK_PATH is
// measured in those coordinates; re-exporting them trimmed or re-framed would
// put the check in the wrong place.
export const VERIFIED_SEAL = '/assets/badges/verified_dsp_seal.png';
export const VERIFIED_SPARK = '/assets/badges/verified_dsp_spark.png';
export const CHECK_PATH = 'M438.5 682 L545 790 L764.6 570.4';
